import React from 'react'
import { Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { LINK_CONTEXTS } from 'src/utils/portal-links'

const OPTIONS = [
  {
    value: LINK_CONTEXTS.PORTAL,
    label: 'In portal',
    icon: 'tabler:layout-navbar',
    hint: 'How learners see it from the portal catalog',
  },
  {
    value: LINK_CONTEXTS.DIRECT,
    label: 'Direct link',
    icon: 'tabler:link',
    hint: 'How it looks when shared on its own',
  },
]

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    flex: 'none',
    padding: 3,
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    background: '#FFFFFF',
  },
  option: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    border: 0,
    borderRadius: '6px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: '12px',
    fontWeight: 500,
    color: '#002E47',
  },
  icon: {
    width: 13,
    height: 13,
  },
  tooltip: {
    padding: '6px 10px',
    borderRadius: '6px',
    background: '#002E47',
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: '12px',
    fontWeight: 500,
  },
  arrow: {
    color: '#002E47',
  },
})

/** "In portal" / "Direct link" segmented control. */
const LinkContextToggle = ({ value, onChange }) => {
  const classes = useStyles()

  return (
    <div className={classes.root} role="radiogroup">
      {OPTIONS.map(option => {
        const active = option.value === value
        return (
          <Tooltip
            key={option.value}
            title={option.hint}
            placement="bottom"
            arrow
            enterDelay={150}
            classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
          >
            <button
              type="button"
              role="radio"
              aria-checked={active}
              aria-label={`${option.label}: ${option.hint}`}
              className={classes.option}
              style={{
                background: active ? '#F4F6F8' : 'transparent',
                boxShadow: active
                  ? 'inset 0 0 0 1px rgba(0,46,71,.12)'
                  : 'none',
              }}
              onClick={() => onChange(option.value)}
            >
              <Icon icon={option.icon} className={classes.icon} />
              {option.label}
            </button>
          </Tooltip>
        )
      })}
    </div>
  )
}

export default LinkContextToggle
